import { render, staticRenderFns } from "./SizeModal.vue?vue&type=template&id=35913348&scoped=true&lang=html&"
import script from "./SizeModal.vue?vue&type=script&lang=js&"
export * from "./SizeModal.vue?vue&type=script&lang=js&"
import style0 from "./SizeModal.vue?vue&type=style&index=0&id=35913348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35913348",
  null
  
)

export default component.exports